import {
    EncryptMethod,
    FIXParser,
    Field,
    Fields,
    LicenseManager,
    Messages,
    type Options,
    ResetSeqNumFlag,
} from 'fixparser';
import { ConsoleLogTransport } from 'fixparser-plugin-log-console';
import { MCPLocal } from './mcp/MCPLocal';

const initializeServer = async () => {
    await LicenseManager.setLicenseKey(process.env.FIXPARSER_LICENSE_KEY!);
    const SENDER = process.env.FIXPARSER_SENDER || 'SENDER';
    const TARGET = process.env.FIXPARSER_TARGET || 'TARGET';

    const fixParser: FIXParser = new FIXParser({
        logging: true,
        logOptions: {
            level: 'info',
            format: 'jsonrpc',
            transport: new ConsoleLogTransport({ format: 'jsonrpc' }),
        },
        plugins: [new MCPLocal({ port: 3099, onReady: () => {} })],
    });

    const sendLogon = () => {
        const logon = fixParser.createMessage(
            new Field(Fields.MsgType, Messages.Logon),
            new Field(Fields.MsgSeqNum, fixParser.getNextTargetMsgSeqNum()),
            new Field(Fields.SenderCompID, SENDER),
            new Field(Fields.SendingTime, fixParser.getTimestamp()),
            new Field(Fields.TargetCompID, TARGET),
            new Field(Fields.ResetSeqNumFlag, ResetSeqNumFlag.Yes),
            new Field(Fields.EncryptMethod, EncryptMethod.None),
            new Field(Fields.HeartBtInt, 10),
        );
        fixParser.send(logon);
    };

    const CONNECT_PARAMS: Options = {
        host: process.env.FIXPARSER_HOST || '10.0.1.42',
        port: process.env.FIXPARSER_PORT ? Number.parseInt(process.env.FIXPARSER_PORT, 10) : 5001,
        protocol: 'tcp',
        sender: SENDER,
        target: TARGET,
        fixVersion: 'FIX.4.4',
        onOpen: () => {
            fixParser.logger.log({
                level: 'info',
                message: 'FIXParser logging in...',
            });
            sendLogon();
        },
        onClose: () => {
            fixParser.logger.log({
                level: 'info',
                message: 'FIXParser disconnected. Reconnecting in 1 second...',
            });
            setTimeout(() => {
                fixParser.connect(CONNECT_PARAMS);
            }, 1000);
        },
    };

    fixParser.connect(CONNECT_PARAMS);
};

initializeServer().catch((err) => console.error('Error initializing server:', err));
